import { useContext } from 'react';
import { useRegionContext } from 'context/RegionContext';
import { FooterWrapper, ZoneTabs, ZoneTabsWrapper } from './Footer.styled';
import { ZoneTile } from './ZoneTile/ZoneTile';
import { MapTourContext } from 'context/MapTourContext';
import { TourType } from 'pages/Map/components/MapTour';
import { useCustomNavigate } from 'hooks/useCustomNavigate';
import { useMapParams } from 'hooks/useMapParams';

export const Footer = () => {
    const { region } = useRegionContext();
    const { isCurrentTourItem } = useContext(MapTourContext);
    const { zoneName: currentZoneName } = useMapParams();
    const { switchMapZone } = useCustomNavigate();

    const handleZoneChange = (zoneName: string) => {
        switchMapZone(currentZoneName, zoneName);
    };

    return (
        <FooterWrapper>
            <ZoneTabsWrapper isMapTourActiveElement={isCurrentTourItem(TourType.TRANSITION_ZONE)}>
                <ZoneTabs>
                    {region.zones?.map((zone, index) => {
                        return (
                            <ZoneTile
                                key={`zone_${index}`}
                                index={index + 1}
                                name={zone.name}
                                isActive={zone.name === currentZoneName}
                                onClick={() => handleZoneChange(zone.name)}
                            />
                        );
                    })}
                </ZoneTabs>
            </ZoneTabsWrapper>
        </FooterWrapper>
    );
};
